import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Space,
  Card,
  message,
  Alert,
  Spin,
  Grid,
} from "antd";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  LoadingOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-number-input/input";

import PageTitle from "../../../Components/PageTitle/pageTitle";

import userServices from "../../../APIs/userServices";
import authCheck from "../../../APIs/authCheck";

const { useBreakpoint } = Grid;

const Login = () => {
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const [isLoading, setIsLoading] = useState(true);

  const [isOtpGet, setIsOtpGet] = useState(false);

  const [buttonLoading, setButtonLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [hpNumberError, setHpNumberError] = useState(false);
  const [phoneValue, setPhoneValue] = useState("");

  const [form] = Form.useForm();

  useEffect(() => {
    // Check if user is already logged in
    const checkAuth = async () => {
      try {
        const response = await authCheck.authCheck();

        if (response?.status === 200) navigate("/profile");
        else setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
      }
    };

    if (localStorage.getItem("uniqueKey") === null) {
      setIsLoading(false);

      return;
    }

    checkAuth();
  }, [navigate]);

  const onFinish = async (values) => {
    setIsLoading(true);
    setErrorMessage("");

    try {
      setButtonLoading(true);

      localStorage.removeItem("uniqueKey");
      // localStorage.clear();

      const response = await userServices.requestOTP(values);

      console.log("response", response);

      if (response?.status !== 200) {
        throw new Error("Login failed. Please check your credentials.");
      } else if (response?.status === 200) {
        // localStorage.setItem("uniqueKey", response?.data?.data);

        messageApi.success("OTP sent successfully!");

        setIsOtpGet(true);

        setButtonLoading(false);

        setIsLoading(false);

        // setTimeout(() => {
        //   navigate("/profile");
        // }, 1000);
      }
    } catch (err) {
      let errorMessage = "Login failed. Please check your credentials.";

      console.error("Login error:", err);

      // messageApi.error(err.response?.data?.message || errorMessage);

      setErrorMessage(err.response?.data?.message || errorMessage);

      setButtonLoading(false);

      setIsLoading(false);
    }
  };

  const onVerifyOTP = async (values) => {
    setIsLoading(true);
    setErrorMessage("");

    try {
      setButtonLoading(true);

      const response = await userServices.login(values);

      console.log("response", response);

      if (response?.status !== 200) {
        throw new Error("Login failed. Please check your credentials.");
      } else if (response?.status === 200) {
        localStorage.setItem("uniqueKey", response?.data?.data);

        messageApi.success("Login successful!");

        setTimeout(() => {
          navigate("/profile");
        }, 1000);
      }
    } catch (err) {
      let errorMessage = "Login failed. Please check your credentials.";

      console.error("Login error:", err);

      // messageApi.error(err.response?.data?.message || errorMessage);

      setErrorMessage(err.response?.data?.message || errorMessage);

      setButtonLoading(false);

      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    const isNumber = /^[0-9]$/.test(e.key);

    if (!isNumber) {
      e.preventDefault(); // block non-numeric keys
    }
  };

  const handleChange = (value, info) => {
    const sanitized = value.replace(/\D/g, "");

    if (sanitized !== value) return;
  };

  return (
    <Space direction="vertical" className="page-container">
      {isLoading && (
        <Spin
          spinning={isLoading}
          indicator={<LoadingOutlined spin />}
          fullscreen
        />
      )}

      {contextHolder}

      <PageTitle
        title="Welcome back to Teamstar"
        subTitle="Log in to access your account and continue your renovation journey."
      />

      <Card
        style={{
          maxWidth: 400,
          margin: "0 auto",
          marginTop: screens.xs ? 40 : 30,
          padding: 20,
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Form
          form={form}
          layout="vertical"
          name="login"
          onFinish={!isOtpGet ? onFinish : onVerifyOTP}
        >
          <span
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              position: "relative",
              marginBottom: 24,
            }}
          >
            <Form.Item
              label="Phone Number"
              name="phoneNumber"
              rules={[{ required: true, message: "" }]}
              hasFeedback
              style={{ width: "100%", marginBottom: 0 }}
            >
              <PhoneInput
                className="custom-phone-input ant-input"
                country="MY"
                international
                withCountryCallingCode
                placeholder="+60"
                value={phoneValue}
                onChange={(value) => {
                  const isValid = /^\+?\d*$/.test(value || "");

                  if (isValid) {
                    setPhoneValue(value);
                  } else {
                    setPhoneValue(""); // clear it if invalid (letter entered)
                  }
                }}
                style={{
                  width: "100%",
                  borderRadius: 6,
                  border:
                    hpNumberError &&
                    form.getFieldError("phoneNumber").length === 0
                      ? "1px solid #ff4d4f"
                      : "1px solid #d9d9d9",
                  padding: "8px 11px",
                  fontSize: 14,
                }}
              />
            </Form.Item>

            {(hpNumberError || /^\+\d+$/.test((phoneValue || "").trim())) && (
              <span
                style={{
                  position: "absolute",
                  right: 13,
                  top: 36,
                  pointerEvents: "none",
                }}
              >
                {hpNumberError ? (
                  <CloseCircleFilled
                    style={{ color: "#ff4d4f", fontSize: 14 }}
                  />
                ) : (
                  <CheckCircleFilled
                    style={{ color: "#52c41a", fontSize: 14 }}
                  />
                )}
              </span>
            )}
          </span>

          {isOtpGet && (
            <Form.Item
              label="OTP"
              name="otpCode"
              rules={[{ required: true, message: "" }]}
              hasFeedback
            >
              <Input.OTP
                id="otpCode"
                name="otpCode"
                length={6}
                formatter={(str) => str.toUpperCase()}
                inputMode="numeric"
                type="tel"
                pattern="\d*"
                onKeyPress={handleKeyPress}
                onChange={handleChange}
                separator={<span>-</span>}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              />
            </Form.Item>
          )}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                backgroundColor: "#002753",
                width: "100%",
                height: 40,
                // marginTop: 20,
                color: "#FFFFFF",
              }}
              loading={buttonLoading}
            >
              {isOtpGet ? "Verify" : "Get OTP"}
            </Button>
          </Form.Item>

          {/* <Form.Item
            label="Email Address"
            name="emailAddress"
            rules={[{ required: true, type: "email", message: "" }]}
            hasFeedback
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "" }]}
            hasFeedback
          >
            <Input.Password />
          </Form.Item> 
           
          <p
            style={{
              color: "#002753",
              cursor: "pointer",
              textAlign: "right",
            }}
            onClick={() => {
              navigate("/forgot-password");
            }}
          >
            Forgot password?
          </p> */}

          {errorMessage && (
            <Alert
              description={errorMessage}
              type="error"
              closable
              onClose={() => setErrorMessage("")}
              showIcon
              style={{
                marginTop: 16,
                marginBottom: 16,
                padding: "8px 12px",
                fontSize: 12,
                lineHeight: "18px",
              }}
            />
          )}

          <p
            style={{
              color: "#4B5563",
              textAlign: "center",
            }}
          >
            Don't have an account?{" "}
            <span
              onClick={() => navigate("/register")}
              style={{
                color: "#002753",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Sign up
            </span>
          </p>
        </Form>
      </Card>
    </Space>
  );
};

export default Login;
